import {
  PROJECT_FETCH_LOADING,
  PROJECT_FETCH_SUCCESS,
  PROJECT_FETCH_ERROR,
  PROJECT_ADD_LOADING,
  PROJECT_ADD_SUCCESS,
  PROJECT_ADD_ERROR,
  PROJECT_DELETE_ERROR,
  PROJECT_DELETE_SUCCESS,
  RESET_RESULT,
  PROJECT_UPDATE_LOADING,
  PROJECT_UPDATE_SUCCESS,
  PROJECT_UPDATE_ERROR,
  TECH_STACK_FETCH_LOADING,
  TECH_STACK_FETCH_SUCCESS,
  TECH_STACK_FETCH_ERROR,
  PROJECT_GET_LOADING,
  PROJECT_GET_SUCCESS,
  PROJECT_GET_ERROR,
  PROJECT_CLOSE_LOADING,
  PROJECT_CLOSE_SUCCESS,
  PROJECT_CLOSE_ERROR,
} from "../types";

const initialState = {
  loading: false,
  page_loading: false,
  result: [],
  typesData:[],
  projectData: [],
  projectResult:[],
  error: "",
  statusMessage:"",
  addProjectError: "",
  updateProjectMessage:"",
  deleteProjectMessage: "",
};

const projectTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case TECH_STACK_FETCH_LOADING:
      return{
        ...state,
        loading:action.payload,
        error:""
      }
    case TECH_STACK_FETCH_SUCCESS:
      return{
        ...state,
        loading:false,
        typesData:action.payload
      }
    case TECH_STACK_FETCH_ERROR:
      return{
         ...state,
        loading: false,
        typesData: [],
        error: action.payload,
      }
    case PROJECT_FETCH_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: "",
      };
    case PROJECT_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };
    case PROJECT_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        result: [],
        error: action.payload,
      };
    case PROJECT_CLOSE_LOADING:
      return{
        ...state,
        loading:action.payload,
        error:""
      }
    case PROJECT_CLOSE_SUCCESS:
      return{
        ...state,
        loading:false,
        statusMessage:action.payload,
        error:""
      }
    case PROJECT_CLOSE_ERROR:
      return{
        ...state,
        loading:false,
        error:action.payload
      }
    case PROJECT_ADD_LOADING:
      return {
        ...state,
        loading: action.payload,
        addProjectError: "",
      };
    case PROJECT_ADD_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
        updateProjectMessage:action.payload
      };
    case PROJECT_ADD_ERROR:
      return {
        ...state,
        loading: false,
        addProjectError: action.payload,
      };
    case PROJECT_GET_LOADING:
      return{
        ...state,
        loading:action.payload,
        addProjectError:""
      };
    case PROJECT_GET_SUCCESS:
      return{
          ...state,
        loading: false,
        projectResult: action.payload,
      }
    case PROJECT_GET_ERROR:
      return {
        ...state,
        loading: false,
        projectResult: [],
        addProjectError: action.payload,
      };
    case PROJECT_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case PROJECT_DELETE_SUCCESS:
      return {
        ...state,
        deleteProjectMessage: action.payload,
      };
    case PROJECT_UPDATE_LOADING:
        return{
            ...state,
            loading:action.payload,
            addProjectError:""
        }
    case PROJECT_UPDATE_SUCCESS:
        return{
            ...state,
            loading:false,
            updateProjectMessage:action.payload
        }
    case PROJECT_UPDATE_ERROR:
        return{
            ...state,
            loading:false,
            addProjectError:action.payload
        }
    case RESET_RESULT:
      return {
        ...state,
        loading: false,
        result: [],
        error: "",
        addProjectError: "",
        deleteProjectMessage: "",
        updateProjectMessage:""
      };
    default:
      return state;
  }
};

export default projectTypeReducer